import { post } from '../request';
/**
 * 冲突区域列表
 * https://yapi.lanhanba.com/project/532/interface/api/73807
 */
export function getConflictList(params?: any) {
  return post('/protectionApply/conflictList', params, {
    needCancel: false,
  });
}
/**
 * 通用审批表单详情
 * https://yapi.lanhanba.com/project/532/interface/api/73828
 */
export function getApprovalInfo(params?:any) {
  return post(`/approval/form/common/detail`, params);
}
